import { MapPin, Trophy, Award, Flag, Users, Timer, Calendar, User } from 'lucide-react';
import { defineSchema, CANONICAL_TRACKS, CANONICAL_CHAMPIONSHIPS, CANONICAL_CATEGORIES, CANONICAL_SESSION_TYPES } from '@shared/search';

export const racesSchema = defineSchema({
  id: 'races',
  title: 'raceSearchHelp.title',
  subtitle: 'raceSearchHelp.subtitle',
  defaultField: 'track',
  fields: {
    track: {
      key: 'track',
      label: 'filter.field.track',
      type: 'enum',
      icon: MapPin,
      allowMultiple: true,
      description: 'filter.desc.track',
      options: CANONICAL_TRACKS,
      example: 'track:Wohlen',
    },
    championship: {
      key: 'championship',
      label: 'filter.field.championship',
      type: 'enum',
      icon: Trophy,
      allowMultiple: true,
      description: 'filter.desc.championship',
      options: CANONICAL_CHAMPIONSHIPS,
      example: 'championship:RMC',
    },
    category: {
      key: 'category',
      label: 'filter.field.category',
      type: 'enum',
      icon: Award,
      allowMultiple: true,
      description: 'filter.desc.category',
      options: CANONICAL_CATEGORIES,
      example: 'category:Max',
    },
    type: {
      key: 'type',
      label: 'filter.field.sessionType',
      type: 'enum',
      icon: Flag,
      allowMultiple: true,
      description: 'filter.desc.sessionType',
      options: CANONICAL_SESSION_TYPES,
      example: 'type:race',
    },
    entries: {
      key: 'entries',
      label: 'filter.field.driverEntries',
      type: 'range',
      icon: Users,
      min: 1,
      max: 60,
      description: 'filter.desc.driverEntries',
      example: 'entries:>=20',
      presets: [
        { label: 'filter.preset.entriesSmall', value: '10', operator: '<' },
        { label: 'filter.preset.entriesMedium', value: '10', highValue: '25', operator: 'between' },
        { label: 'filter.preset.entriesLarge', value: '25', operator: '>' },
      ],
    },
    laps: {
      key: 'laps',
      label: 'filter.field.laps',
      type: 'range',
      icon: Timer,
      unit: 'filter.unit.laps',
      min: 1,
      max: 50,
      description: 'filter.desc.raceLaps',
      example: 'laps:>5',
    },
    season: {
      key: 'season',
      label: 'filter.field.season',
      type: 'number',
      icon: Calendar,
      description: 'filter.desc.season',
      example: 'season:2026',
      presets: [
        { label: '2026', value: '2026', operator: '=' },
        { label: '2025', value: '2025', operator: '=' },
        { label: '2024', value: '2024', operator: '=' },
      ],
    },
    driver: {
      key: 'driver',
      label: 'filter.field.driver',
      type: 'text',
      icon: User,
      placeholder: 'filter.placeholder.driver',
      description: 'filter.desc.raceDriver',
      example: 'driver:Yanick',
    },
    from: {
      key: 'from',
      label: 'filter.field.date',
      type: 'dateRange',
      icon: Calendar,
      description: 'filter.desc.raceDate',
      example: 'from:-1y',
      datePresets: [
        { label: 'filter.preset.today', value: 'today' },
        { label: 'filter.preset.last30d', value: '-30d' },
        { label: 'filter.preset.last90d', value: '-90d' },
        { label: 'filter.preset.last1y', value: '-1y' },
      ],
    },
  },
  examples: [
    { q: 'track:Wohlen season:2026', desc: 'filter.races.example1' },
    { q: 'category:"Senior MAX" entries:>=20', desc: 'filter.races.example2' },
    { q: 'driver:Yanick from:-1y', desc: 'filter.races.example3' },
  ],
});
